import React, { FC, useEffect, useState } from 'react';
import { ApolloClient, ApolloProvider, from, HttpLink, InMemoryCache } from '@apollo/client';
import { useAuth } from '../../contexts/auth.context.tsx';
import { onError } from '@apollo/client/link/error';
import { useNavigate } from 'react-router-dom';
import { Paths } from '../../constants/paths.ts';

export interface GraphqlProviderProps {
  children: React.ReactNode;
}

export const GraphqlProvider: FC<GraphqlProviderProps> = ({ children }) => {
  const { accessToken, isInitialized } = useAuth();
  const navigate = useNavigate();
  const [httpLink, setHttpLink] = useState<HttpLink>(
    new HttpLink({
      uri: import.meta.env.VITE_API_HOST
    })
  );

  const errorLink = onError(({ graphQLErrors }) => {
    graphQLErrors?.forEach((error) => {
      if (isInitialized) {
        if (error.message === 'Token expired') {
          navigate(Paths.LOGIN);
        }
      }
    });
  });

  useEffect(() => {
    if (!accessToken) return;
    setHttpLink(
      new HttpLink({
        uri: import.meta.env.VITE_API_HOST,
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
    );
  }, [accessToken]);

  const apolloClient = new ApolloClient({
    cache: new InMemoryCache({
      resultCaching: true
    }),
    link: from([errorLink, httpLink]),
    defaultOptions: {
      query: {
        errorPolicy: 'ignore',
        returnPartialData: true
      }
    }
  });
  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
};
